module.exports = __webpack_public_path__ + "static/media/Dotmatrx.95980185.ttf";